// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cosmic_informational_input_text[data-v-07e7c0b0]{font-size:18px!important}.inputs[data-v-07e7c0b0]{margin:auto 0;display:grid;grid-template-rows:auto;grid-template-columns:100px 100px 100px 50px}.inputs i[data-v-07e7c0b0]{margin-bottom:4px}.dateDisplay[data-v-07e7c0b0]{font-size:1.2em}[data-v-07e7c0b0]:deep(.v-text-field__details){display:none}.v-messages[data-v-07e7c0b0]{padding-left:12px}", ""]);
// Exports
module.exports = exports;
